import styled from "styled-components"


export const Container = styled.div `
    width: 100%;
    border-bottom: 2px solid var(--color-gray-3);

    #profileName {
        h1 {
            color: #FFFFFF;
        }
    }

    #profileModule {
        h1 {
            color: var(--color-primary);
        }
    }
`